import React from 'react';
import { View } from 'react-native';
import Svg, { Rect } from 'react-native-svg';

// Code 128 set B. Patterns 0-106; the stop pattern is 7 widths.
const PATTERNS = [
  '212222', '222122', '222221', '121223', '121322', '131222', '122213', '122312', '132212', '221213',
  '221312', '231212', '112232', '122132', '122231', '113222', '123122', '123221', '223211', '221132',
  '221231', '213212', '223112', '312131', '311222', '321122', '321221', '312212', '322112', '322211',
  '212123', '212321', '232121', '111323', '131123', '131321', '112313', '132113', '132311', '211313',
  '231113', '231311', '112133', '112331', '132131', '113123', '113321', '133121', '313121', '211331',
  '231131', '213113', '213311', '213131', '311123', '311321', '331121', '312113', '312311', '332111',
  '314111', '221411', '431111', '111224', '111422', '121124', '121421', '141122', '141221', '112214',
  '112412', '122114', '122411', '142112', '142211', '241211', '221114', '413111', '241112', '134111',
  '111242', '121142', '121241', '114212', '124112', '124211', '411212', '421112', '421211', '212141',
  '214121', '412121', '111143', '111341', '131141', '114113', '114311', '411113', '411311', '113141',
  '114131', '311141', '411131', '211412', '211214', '211232', '2331112',
];

const START_B = 104;
const STOP = 106;

function patternToBits(pattern) {
  const bits = [];
  let bar = true;
  for (let i = 0; i < pattern.length; i += 1) {
    const width = pattern.charCodeAt(i) - 48;
    for (let n = 0; n < width; n += 1) {
      bits.push(bar ? 1 : 0);
    }
    bar = !bar;
  }
  return bits;
}

/** Code 128 B bars for an alphanumeric voucher code. Null if a character is outside the set. */
export function encodeCode128B(value) {
  const text = String(value || '');
  if (!text) return null;

  const codes = [START_B];
  for (let i = 0; i < text.length; i += 1) {
    const code = text.charCodeAt(i) - 32;
    if (code < 0 || code > 94) return null;
    codes.push(code);
  }

  let sum = START_B;
  for (let i = 1; i < codes.length; i += 1) {
    sum += codes[i] * i;
  }
  codes.push(sum % 103);
  codes.push(STOP);

  const bits = [];
  for (let q = 0; q < 10; q += 1) bits.push(0);
  codes.forEach((code) => {
    patternToBits(PATTERNS[code]).forEach((bit) => bits.push(bit));
  });
  for (let q = 0; q < 10; q += 1) bits.push(0);
  return bits;
}

export default function CashierBarcode({ value }) {
  // Spaces stay on the printed code. The scan value is the same text without them.
  const bits = encodeCode128B(String(value || '').replace(/ /g, ''));
  if (!bits) return null;

  const height = 78;
  return (
    <View style={{ width: '100%', backgroundColor: '#FFFFFF', paddingVertical: 8, paddingHorizontal: 8 }}>
      <Svg width="100%" height={height} viewBox={`0 0 ${bits.length} ${height}`} preserveAspectRatio="none">
        {bits.map((on, index) => (
          on ? <Rect key={index} x={index} y={0} width={1} height={height} fill="#111111" /> : null
        ))}
      </Svg>
    </View>
  );
}
